import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import "./globals.css";

const container = document.getElementById("root")!;

// BrowserRouter wraps <App/> here (not inside App.tsx) so that
// scripts/prerender-landing.mjs can wrap the identical <App/> tree in
// MemoryRouter instead - same component structure both ways, which is what
// makes hydration below actually match instead of mismatching.
const app = (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// "/" is prerendered at build time (scripts/prerender-landing.mjs) so its
// content already exists in the DOM on load - hydrateRoot adopts it instead
// of tearing it down and re-rendering, avoiding a flash. Every other route
// still gets an empty #root from the SPA shell, so a plain client render is
// correct there.
if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}

// Registra o service worker só em produção — em dev ele atrapalharia o HMR
// e cachearia respostas do servidor de desenvolvimento.
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // Falha silenciosa: o app funciona normalmente sem o service worker,
      // só perde o cache offline.
    });
  });

  // A primeira instalação apenas assume o controle; não exige recarregar.
  // Uma troca posterior de worker indica atualização de uma aba já controlada.
  let hadController = Boolean(navigator.serviceWorker.controller);
  let reloadingForNewVersion = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (!hadController) {
      hadController = true;
      return;
    }
    if (reloadingForNewVersion) return;
    reloadingForNewVersion = true;
    window.location.reload();
  });
}
